import { SerializedStyles, css } from '@emotion/react';
import { Theme } from '@zip/theme';

export const container = css`
  margin: 0;
`;

export const stepper = css`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.5rem;
  padding: 24px 1rem 26px 1rem;
`;

export const stepButton =
  (isActive: boolean) =>
  (theme: Theme): SerializedStyles =>
    css`
      width: 12px;
      height: 10px;
      background-color: ${isActive
        ? theme.colors.primary.medium
        : theme.colors.neutral[200]};
      border: none;
      cursor: pointer;
      transform: skew(10deg);
    `;
